export const REPLACE_STATE_EVENT = 'castReplaceState';
